import { reactive } from 'vue'

const state = reactive({
  timezone: '',
  loaded: false
})

/** 仍拉取站点时区配置（后台/兼容用），前端展示默认跟设备本地时区 */
export async function loadTimezone() {
  if (state.loaded) return
  try {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || ''
    const res = await fetch(`${baseUrl}/api/system/config`)
    const json = await res.json()
    if (json?.data?.system?.timezone) {
      state.timezone = json.data.system.timezone
    }
  } catch (e) {
    console.warn('[timezone] Failed to load site timezone:', e.message)
  }
  state.loaded = true
}

export function getSiteTimezone() {
  return state.timezone || undefined
}

/** 前端展示一律用设备本地时区（不强制站点时区） */
export function getDisplayTimezone() {
  return undefined
}

export function formatDateTime(dateStr, locale, options = {}) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  const defaults = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }
  const opts = { ...defaults, ...options }
  // 不设置 timeZone → 浏览器按设备本地时区格式化
  delete opts.timeZone
  return date.toLocaleString(lang, opts)
}

export function formatDate(dateStr, locale) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  return date.toLocaleDateString(lang, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

export function formatTime(dateStr, locale) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return '-'
  const lang = locale || 'en'
  return date.toLocaleTimeString(lang, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}

export function formatTimezoneLabel() {
  try {
    const part = new Intl.DateTimeFormat('en-US', { timeZoneName: 'shortOffset' })
      .formatToParts(new Date())
      .find(p => p.type === 'timeZoneName')
    if (part?.value) return part.value
  } catch (_e) { /* ignore */ }
  const off = -new Date().getTimezoneOffset() / 60
  const sign = off >= 0 ? '+' : ''
  return `UTC${sign}${off}`
}
